import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'

import { Subscription } from 'rxjs'
import { MachineStateComputed } from '../../../../models/states-computed.models'
import { TouaregControlStateParamsService } from '../../../../services/touareg-control-state-params.service'
import { TouaregControlStateMachineService } from '../../../../services/touareg-control-state-machine.service'
import { TouaregControlLayoutMessage, TouaregControlStateLayoutComponent } from '../../layout/touareg-control-state-layout.component'
import { TouaregControlProgressButtonComponent } from '../../components/touareg-control-progress-button/touareg-control-progress-button.component';
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-touareg-control-state-accepting-user-choice',
  templateUrl: './touareg-control-state-accepting-user-choice.component.html',
  styleUrls: ['./touareg-control-state-accepting-user-choice.component.scss'],
  imports: [TouaregControlStateLayoutComponent, TouaregControlProgressButtonComponent, Samv2Module],
})
export class TouaregControlStateAcceptingUserChoiceComponent {
  @Output()
  waitingComplete = new EventEmitter<boolean>()

  @Input()
  state!: MachineStateComputed

  public okFetching!: boolean
  public cancelFetching!: boolean
  public message!: TouaregControlLayoutMessage

  private _isActionCancelDoneSubs$!: Subscription
  private _isActionOkDoneSubs$!: Subscription

  constructor(private _stateMachine: TouaregControlStateMachineService) {}

  private _unsubscribe() {
    if (!!this._isActionCancelDoneSubs$)
      this._isActionCancelDoneSubs$.unsubscribe()
    if (!!this._isActionOkDoneSubs$) this._isActionOkDoneSubs$.unsubscribe()
  }

  public onAccept() {
    this._unsubscribe()
    const state$ = this._stateMachine.actionFinalConfirm()
    this._isActionOkDoneSubs$ = state$.subscribe((s) => (this.okFetching = !s))
  }

  public onCancel() {
    this._unsubscribe()
    const state$ = this._stateMachine.actionFinalCancel()
    this._isActionCancelDoneSubs$ = state$.subscribe(
      (s) => (this.cancelFetching = !s)
    )
  }

  public onComplete() {
    this.waitingComplete.emit()
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // if (!!this._touaregStatesSubs$) this._touaregStatesSubs$.unsubscribe()
    this._unsubscribe()
  }
}
